import _isObject from "../internals/is-object";
var exports = {};
var isObject = _isObject;
exports = function (argument) {
  return isObject(argument) || argument === null;
};
export default exports;